jQuery(function ($) {
  let $doc = $(document),
    $body = $("body"),
    $cartForm = $("form.cart"),
    $cartTable = null,
    $cartCounts = null,
    $cartCountBubbles = null,
    $cartUpdateButton = null,
    $cartCheckoutButton = null,
    currentCart = null,
    initialItems = [],
    items = [],
    changeCartItemTimeoutId = 0;

  if ($cartForm.length && $cartForm.hasClass("wb-cart--enabled")) {
    loadCart().then(() => {
      theme.CurrencyConverter.addLoadedHandler(init);
    });
  }

  function init() {
    initElements();
    initEvents();
    syncCartItems();
    syncCartTable();
    syncPrices();
    syncCartCounts();
    $doc.trigger("cart_init_complete");
  }

  function loadCart() {
    return theme.CartV2.load().then((cart) => (currentCart = cart));
  }

  function initElements() {
    $cartTable = $cartForm.find(".js-wb-cart-table");
    $cartUpdateButton = $cartForm.find("button[name=update]");
    $cartCheckoutButton = $cartForm.find("button[name=checkout]");
    $cartUpdateButton.attr("disabled", true);
    $cartCounts = $(".cart-link__count");
    $cartCountBubbles = $(".cart-link__bubble");

    $cartForm.prepend(
      '<div class="wb-cart__loading-indicator"><div class="wb-cart__loading-indicator-spinner"><div class="wb-cart__loading-indicator-spinner-circle"></div></div></div>'
    );
  }

  function initEvents() {
    $doc.on("cart_init_complete", onInitComplete);
    $doc.on("cart_updated", onCartUpdated);
    $cartForm.on("input", ".js-wb-qty-input", onQtyInputChange);
    $cartForm.on("click", "button[name=update]", onUpdateButtonClick);
    $cartForm.on("click", "button.js-wb-qty-btn", onPlusMinusButtonClick);
    $cartForm.on("click", "button.js-wb-remove-btn", onRemoveButtonClick);
  }

  function onQtyInputChange(e) {
    const $input = $(e.target).closest(".js-wb-qty-input"),
      itemId = $input.data("item-id"),
      variantId = $input.data("variant-id");

    validateQuantityInputValue($input);

    const qty = $input.val();

    changeItemQuantity(itemId, variantId, qty);
  }

  function onPlusMinusButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const $button = $(e.target).closest('.js-wb-qty-btn'),
      $input = $button.closest(".js-wb-qty").find(".js-wb-qty-input");

    qty = +$input.val();
    qty += $button.hasClass("js-wb-qty-plus") ? 1 : -1;
    $input.val(qty);
    $input.trigger("input");
  }

  function onRemoveButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const $button = $(e.target).closest(".js-wb-remove-btn"),
      itemId = $button.data("item-id");

    removeCartItem(itemId);
  }

  function validateQuantityInputValue($input) {
    let qty = +$input.val(),
      max = $input.attr('max');

    if (qty < 0) {
      qty = 0;
    } else if(typeof max !== 'undefined' && qty > max) {
      qty = max;
    }
  
    $input.val(qty);
  }

  function getCartItemById(itemId) {
    return items.find((item) => item.id == itemId);
  }

  function getCartItemVariants(itemId) {
    return getCartItemById(itemId).variations;
  }

  function getCartItemVariantById(itemId, variantId) {
    return getCartItemVariants(itemId).find((v) => v.variant_id == variantId);
  }

  function removeCartItem(itemId) {
    updates = getCartItemVariants(itemId).reduce(
      (a, v) => ((a[v.key] = 0), a),
      {}
    );

    blockCart();

    theme.CartV2.updateCart(updates).finally(() => unblockCart());
  }

  function changeItemQuantity(itemId, variantId, qty) {
    qty = parseInt(qty);

    items = items.map((item) => {
      if (item.id == itemId) {
        item.variations = item.variations.map(
          (v) => (v.variant_id == variantId ? (v.quantity = qty) : 0, v)
        );
      }

      return item;
    });

    syncCartItemVariant(itemId, variantId);
    syncCartItemTotals(itemId);
    syncPrices();
    syncCartUpdateButton();

    changeShopifyCartItemDebounced(itemId, variantId);
  }

  function changeShopifyCartItemDebounced(itemId, variantId) {
    clearTimeout(changeCartItemTimeoutId);

    changeCartItemTimeoutId = setTimeout(() => {
      changeShopifyCartItem(itemId, variantId);
    }, 1000);
  }

  function changeShopifyCartItem(itemId, variantId) {
    const variant = getCartItemVariantById(itemId, variantId);
  
    blockCart();

    theme.CartV2.updateCart({ [variant.key]: variant.quantity }).finally(() =>
      unblockCart()
    );
  }

  function onInitComplete() {
    $cartForm.addClass("wb-cart--loaded");
  }

  function onCartUpdated(e, cart) {
    currentCart = cart;
    syncCartItems();
    syncCartTable();
    syncCartOverview();
    syncCartUpdateButton();
    syncCartCheckoutButton();
    syncPrices();
  }

  function onUpdateButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();

    blockCart();
    $cartUpdateButton.attr("disabled", true).addClass("wb-btn--loading");

    updateShopifyCartByCurrentItems()
      .then(() => {
        displayCartUpdatedMessage();
      })
      .finally(() => {
        unblockCart();
        $cartUpdateButton.removeClass("wb-btn--loading");
      });
  }

  function blockCart() {
    $cartForm.css({ pointerEvents: "none", position: "relative", zIndex: 1 });
    $cartForm.addClass("is-blocked is-loading");
    $cartForm.append('<div class="wb-cart__block-overlay"></div>');
  }

  function unblockCart() {
    $cartForm.removeClass("is-blocked is-loading");
    $cartForm.css({ pointerEvents: "", position: "" });
    $cartForm.find(".wb-cart__block-overlay").remove();
  }

  function updateShopifyCartByCurrentItems() {
    const updates = items.reduce((a, item) => {
      const vars = item.variations.reduce(
        (a, v) => ((a[v.key] = +v.quantity), a),
        {}
      );

      return {
        ...a,
        ...vars,
      };
    }, {});

    return theme.CartV2.updateCart(updates);
  }

  function displayCartUpdatedMessage() {
    const originalText = $cartUpdateButton.text();
    $cartUpdateButton.text(t("cart.updated", "Updated!"));
    setTimeout(() => $cartUpdateButton.text(originalText), 2500);
  }

  function syncCartItems() {
    let tempItems = {};

    currentCart.items.forEach((item) => {
      if (!tempItems[item.product_id]) {
        tempItems[item.product_id] = {
          id: item.product_id,
          title: item.product_title,
          url: item.url,
          imageUrl: imageUrl(item.image, "100x"),
          variations: [],
        };
      }
      
      item.variant_title = item.variant_title
        ? item.variant_title
        : t("cart.defaultVariantTitle");

      tempItems[item.product_id].variations.push(item);
    });

    items = Object.values(tempItems);
    items.map((item) => {
      const product = theme.CartV2.products?.find(
        (i) => i.id === `gid://shopify/Product/${item.id}`
      );
      if (product) {
        product.variants.forEach((v) => {
          const cartItemVariant = item.variations.find((i2) => i2.id == v?.id.split('/').at(-1));
          if (!cartItemVariant) {
            item.variations.push({
              id: v?.id.replace("gid://shopify/ProductVariant/", ""),
              key: v?.id.replace("gid://shopify/ProductVariant/", ""),
              variant_id: v?.id.replace("gid://shopify/ProductVariant/", ""),
              variant_title: v?.title,
              quantity: 0,
              price: 0,
              availableForSale: v.availableForSale,
              currentlyNotInStock: v.currentlyNotInStock,
              quantityAvailable: v.quantityAvailable,
            });
          } else {
            cartItemVariant.availableForSale = v.availableForSale;
            cartItemVariant.currentlyNotInStock = v.currentlyNotInStock;
            cartItemVariant.quantityAvailable = v.quantityAvailable;
          }
        });
      }
      return item;
    });

    sortItemsVariationsBySize();
    initialItems = generateInitialItems(items);
  }

  function sortItemsVariationsBySize() {
    let variantsOrder = theme.settings.cartVariantsOrder;
    variantsOrder = variantsOrder
      ? variantsOrder.split(",").map((a) => a.toUpperCase().trim())
      : [];

    items.forEach((item) => {
      // sort by id
      item.variations.sort((v1, v2) => v1.variant_id - v2.variant_id);

      // sort by custom order coming from theme settings (e.g. [XS, SM, M, L, XL])
      item.variations.sort((v1, v2) => {
        index1 = variantsOrder.indexOf(v1.variant_title.toUpperCase());
        index2 = variantsOrder.indexOf(v2.variant_title.toUpperCase());

        if (index1 != -1 && index2 != -1) {
          return index1 - index2;
        }

        return index1 != -1 ? -1 : index2 != -1 ? 1 : 0;
      });
    });
  }

  function syncCartTable() {
    $cartTable.html(_getCartTableHtml());
  }

  function syncPrices() {
    theme.CurrencyConverter.maybeConvertAll();
  }

  function syncCartItemVariant(itemId, variantId) {
    const $item = $(`#wbCartItem__${itemId}`),
      $variant = $item.find(`#wbCartItemVariant__${variantId}`),
      $price = $variant.find(".js-wb-cart-item-price"),
      variantData = getCartItemVariantById(itemId, variantId);

    $price.html(money(variantData.quantity * variantData.price));
  }

  function syncCartItemTotals(itemId) {
    const $item = $(`#wbCartItem__${itemId}`),
      itemData = getCartItemById(itemId),
      $amount = $item.find(".js-wb-cart-item-amount"),
      $total = $item.find(".js-wb-cart-item-total");

    $amount.html(getItemAmount(itemData));
    $total.html(money(getItemTotal(itemData)));
  }

  function syncCartOverview() {
    const $subtotal = $cartForm.find(".sub_totlesss .gip-cart-subtotal"),
      $total = $cartForm.find(".totle_amount .gip-cart-subtotal");

    $subtotal.html(money(currentCart.total_price));
    $total.html(money(currentCart.total_price));
  }

  function syncCartCounts() {
    const count = getCurrentItemsCount();
    $cartCounts.text(count);
    $cartCountBubbles.toggleClass("cart-link__bubble--visible", count > 0);
  }

  function syncCartUpdateButton() {
    if ($cartUpdateButton.length) {
      $cartUpdateButton.attr("disabled", !checkCartItemsChanged());
    }
  }

  function syncCartCheckoutButton() {
    if (!items.length && $cartCheckoutButton.length) {
      $cartCheckoutButton.hide();
    }
  }

  function generateInitialItems(items) {
    let newItems = [];

    for (let { id, variations } of items) {
      let newItem = { id, variations: [] };

      for (let { variant_id, quantity } of variations) {
        newItem.variations.push({ variant_id, quantity });
      }

      newItems.push(newItem);
    }

    return newItems;
  }

  function checkCartItemsChanged() {
    return !deepEqualItems(items, initialItems);
  }

  function _getCartTableHtml() {
    if (!items.length) {
      return _getEmptyCartHtml();
    }

    const itemsHtml = items.map(_getCartTableItemHtml).join("");

    return `
<div class="wb-cart__table">
    <div class="wb-cart__items">
        ${itemsHtml}
    </div>
</div>
    `;
  }

  function _getEmptyCartHtml() {
    return `<div class="wb-cart__empty">
<div class="wb-cart__empty-message">${t("cart.empty")}</div>
<div class="wb-cart__empty-button">
    <a href="${_getAllProductsUrl()}" class="btn btn--small">${t("cart.continueShopping")}</a>
</div>
</div>`;
  }

  function _getAllProductsUrl() {
    return theme.routes.allProducts || "/collections/all";
  }

  function _getCartTableItemHtml(item) {
    return `
<div id="wbCartItem__${item.id}" class="wb-cart__item">
  <div class="wb-cart__item-main">
    <div class="wb-cart__item-image">
        <a href="${item.url}">
            <img srcset="${item.imageUrl}" alt="${item.title}">
        </a>
    </div>
    <h3 class="wb-cart__item-title">
        <a href="${item.url}">${item.title}</a>
    </h3>
  </div>

  <div class="wb-cart__item-side">
    <div class="wb-cart__item-side-table">
        ${_getCartTableItemSideHtml(item)}
    </div>
  </div>
</div>
    `;
  }

  function _getCartTableItemSideHtml(item) {
    let topRow = '<div class="wb-cart__item-top-row">';
    topRow += item.variations
      .map(
        (v) =>
          `<div class="wb-cart__item-top-row-item wb-cart__item-top-row-item--variant">${v.variant_title}</div>`
      )
      .join("");
    topRow += `<div class="wb-cart__item-top-row-item wb-cart__item-top-row-item--amount">${t(
      "cart.amount"
    )}</div>`;
    topRow += `<div class="wb-cart__item-top-row-item wb-cart__item-top-row-item--total">${t(
      "cart.total"
    )}</div>`;
    topRow += "</div>";

    let middleRow = '<div class="wb-cart__item-middle-row">';
    middleRow += item.variations
      .map(
        (v) => {
          let maxAttribute = '';
          if(!v.currentlyNotInStock) {
            maxAttribute = `max="${v.quantityAvailable}"`;
          }
          
          let stockCountHtml = '';
          if(v.availableForSale && v.quantityAvailable > 0) {
            let stockStatus = v.quantityAvailable > 50 ? 'high-stock' : 'low-stock';
            stockCountHtml = `<div class="wb-cart__item-stock wb-cart__item-stock--${stockStatus}">${v.quantityAvailable} in stock</div>`;
          }
          
          if(!v.availableForSale) {
            return `<div id="wbCartItemVariant__${
              v.variant_id
            }" class="wb-cart__item-middle-row-item wb-cart__item-middle-row-item--variant">
<div class="wb-cart__item-out-of-stock">Out<br>of<br>Stock</div>
</div>`;
          }
          
          return `
<div id="wbCartItemVariant__${
            v.variant_id
          }" class="wb-cart__item-middle-row-item wb-cart__item-middle-row-item--variant">
  <div class="wb-cart__item-middle-row-item-inner">
    <div class="wb-cart__item-qty js-wb-qty">
      <input type="number"
              ${maxAttribute}
              class="wb-cart__item-qty-input
              js-wb-qty-input"
              value="${v.quantity}"
              data-item-id="${item.id}"
              data-variant-id="${v.variant_id}">
      <div class="wb-cart__item-qty-buttons">
          <button type="button" class="wb-cart__item-qty-btn wb-cart__item-qty-plus js-wb-qty-btn js-wb-qty-plus" title="${t(
            "cart.increment"
          )}" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                        <path d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 9h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                                              fill="none"></path>
                                        <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                                    </svg></button>
          <button type="button" class="wb-cart__item-qty-btn wb-cart__item-qty-minus js-wb-qty-btn js-wb-qty-minus" title="${t(
            "cart.decrement"
          )}" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                        <path d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 9H7v-2h10v2z"
                                              fill="none"></path>
                                        <path d="M7 11h10v2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                                    </svg></button>
      </div>
    </div>
    
    ${stockCountHtml}

    <div class="wb-cart__item-price js-wb-cart-item-price">
      ${money(v.quantity * v.price)}
    </div>
  </div>
</div>`;
        }
      )
      .join("");

    let amount = getItemAmount(item);
    let total = getItemTotal(item);

    middleRow += `<div class="wb-cart__item-middle-row-item wb-cart__item-middle-row-item--amount js-wb-cart-item-amount">${amount}</div>`;
    middleRow += `<div class="wb-cart__item-middle-row-item wb-cart__item-middle-row-item--total js-wb-cart-item-total">${money(
      total
    )}</div>`;
    middleRow += "</div>";

    let bottomRow = `<div class="wb-cart__item-bottom-row">
    <button type="button" class="wb-cart__item-remove js-wb-remove-btn" data-item-id="${
      item.id
    }">
    <span class="wb-cart__item-remove-icon">×</span>
    ${t("cart.remove")}
    </button>
</div>`;

    return topRow + middleRow + bottomRow;
  }

  function getCurrentItemsCount() {
    return currentCart.item_count;
  }

  function getItemAmount(item) {
    return item.variations.reduce((a, v) => a + +v.quantity, 0);
  }

  function getItemTotal(item) {
    return item.variations.reduce((a, v) => a + v.quantity * v.price, 0);
  }

  function imageUrl(url, modifier) {
    if (!url) {
      return "data:image/jpeg;base64,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";
    }

    return url.replace(/\.\w+(\?v=.+)?$/, (r) => `_${modifier}${r}`);
  }

  function money(price) {
    price = theme.CurrencyConverter.formatMoney(price);

    return `<span class="money">${price}</span>`;
  }

  function getCurrentCurrency() {
    if (
      typeof DoublyGlobalCurrency !== "undefined" &&
      typeof DoublyGlobalCurrency.convertAll === "function"
    ) {
      return DoublyGlobalCurrency.currentCurrency;
    }

    return "EUR";
  }

  function deepEqualItems(x, y) {
    if (x.length !== y.length) {
      return false;
    }

    for (let a of x) {
      isItemEqual = false;

      for (let b of y) {
        if (a.id === b.id) {
          let [varsA, varsB] = [a.variations, b.variations];

          if (varsA.length !== varsB.length) {
            return false;
          }

          for (let vA of varsA) {
            isVariationEqual = false;

            for (let vB of varsB) {
              if (vA.variant_id === vB.variant_id) {
                isVariationEqual = vA.quantity === vB.quantity;
                break;
              }
            }

            if (!isVariationEqual) {
              return false;
            }
          }

          isItemEqual = true;

          break;
        }
      }

      if (!isItemEqual) {
        return false;
      }
    }

    return true;
  }

  function t(key, def = "") {
    key = key.split(".");
    let o = theme.strings;
    for (let k of key) {
      if (!(o = o[k])) {
        break;
      }
    }

    return o || def;
  }
});
